import { CLUSTERS_PER_REGION } from './constants.js';
import { POCKET_MAX } from './citygen.js';
// ---------------------------------------------------------------------------
// The war: one open match anyone joins by pressing Play.
//
// It starts with whoever pressed Play in a ten-second call-up and fills its
// board a region a round, NPCs taking every seat no human has. While its first
// board stands, a newcomer deploys into the next region to be dealt, or takes
// over an NPC's city. Once that board has re-formed (the first stage change)
// the war is closed to newcomers for good, and only those already in it fight
// the endgame.
//
// The invariants, and where each is held:
//
//  1. One clock: a war is one Match with one round and one phase. Nothing on a
//     cluster or region has a clock of its own.
//  2. A region is dealt only at the top of a plan phase (MatchRoom
//     activateRegion throws otherwise), so it plans and defends before it can
//     be struck.
//  3. At most `regions` regions are dealt (WAR_REGIONS), and
//  4. one a round: region i at round i + 1 (activateRegion checks both).
//  5. A human may take over an NPC's seat while admissions are open, and
//  6. never a human's (GameEngine.transferSeat throws on a human seat).
//  7. The first re-formed board locks admissions, and nothing unlocks them
//     (lockAdmissions; nothing writes `lockedAt` but it).
//  8. A commander already in the war gets back in at any time (WarDesk checks
//     membership before it looks at admissions), but
//  9. nobody new is admitted once locked (MatchRoom.admit).
// 10. How many wars run at once is the server's setting (WarDesk
//     maxConcurrent), not something the match assumes.
// ---------------------------------------------------------------------------
/** Regions in a war's initial battlefield. */
export const WAR_REGIONS = 4;
/** Seats in one region: four 4v4 clusters. */
export const WAR_SEATS_PER_REGION = CLUSTERS_PER_REGION * POCKET_MAX * 2;
/** The call-up between the first Play and round 1. */
export const WAR_LAUNCH_MS = 10_000;
/**
 * The call-up of a battle against other commanders (MatchConfig.cluster):
 * long enough for a few to find the same one, since nobody joins it once it
 * starts. It ends early the moment every seat has a human waiting for it.
 */
export const BATTLE_LAUNCH_MS = 30_000;
export function newWar(regions = WAR_REGIONS, now = Date.now(), launchMs = WAR_LAUNCH_MS) {
    return { regions, activated: 0, launchEndsAt: now + launchMs, lockedAt: null };
}
/** Where a war stands; null for a match that is not one. */
export function warState(match) {
    const war = match.war;
    if (!war)
        return null;
    if (match.status === 'FINISHED')
        return 'COMPLETE';
    if (war.lockedAt)
        return 'LOCKED_ENDGAME';
    if (match.status === 'LOBBY')
        return 'LAUNCHING';
    return war.activated < war.regions ? 'MOBILISING' : 'OPEN_BACKFILL';
}
/** Whether a war takes commanders who are not already in it. */
export function admissionsOpen(match) {
    const state = warState(match);
    return state === 'LAUNCHING' || state === 'MOBILISING' || state === 'OPEN_BACKFILL';
}
/**
 * Whether regions are still to be dealt. While they are, the side that has
 * lost every city dealt so far has not lost the war, and a board whose
 * clusters are all decided is not re-formed: more of it is on the way.
 */
export function mobilising(match) {
    const war = match.war;
    return war != null && war.activated < war.regions;
}
/**
 * Close a war to newcomers, for good. The first call records when; any later
 * one changes nothing, and there is deliberately no way back.
 */
export function lockAdmissions(war, round, stage) {
    if (war.lockedAt)
        return;
    war.lockedAt = Object.freeze({ round, stage });
}
//# sourceMappingURL=war.js.map